/*
  Secondary Categories
 */
import { componentNames, pathNames } from './constants';
import { getPathConfiguration } from './utils';

const secondaryCategoryOnPrimary = [
  {
    topic: 'Membership / Rewards / Bonus Card',
    headline: 'Membership headline:',
    categories: [
      {
        name: 'membership-lookup',
        label: 'Member number lookup',
        showHelpLinks: true,
        links: [{
          name: 'membership-number-lookup',
          label: 'REI Co-op Member number lookup',
          url: '/membership/lookup',
        },
        {
          name: 'membership-lookup-find-member-number-and-rewards-balance',
          label: 'How do I find my member number and total reward balance?',
          url: '/help?a=How-do-I-find-my-member-number-and-Total-REI-Rewards-balance?---id--vr0kStjsSOqZXOsEV5gj9A',
        },
        {
          name: 'membership-lookup-cant-remember-user-name-password',
          label: 'I can\'t remember my user name and password, but I am a member, what should I do?',
          url: '/help?a=I-can%27t-remember-my-user-name-and-password,-but-I-am-a-member.-What-should-I-do?---id--KziZehTeRruseo64rd9UaA',
        }],
      },
      {
        name: 'membership-rewards-balance',
        label: 'Rewards balance',
        showHelpLinks: true,
        links: [{
          name: 'membership-rewards-lookup',
          label: 'Rewards balance lookup page',
          url: '/membership/lookup',
        },
        {
          name: 'membership-rewards-when',
          label: 'When do I get my Co-op Member Reward?',
          url: '/help?a=When-do-I-get-my-Co-op-Member-Reward---id--0BdciJYRQ7acdkO6JF7xFA',
        },
        {
          name: 'membership-rewards-how',
          label: 'How do I earn a Co-op Member Reward?',
          url: '/help?a=How-do-I-earn-a-Co-op-Member-Reward---id--apT8JbKWQtG5mFZwOzpjsw',
        },
        {
          name: 'membership-rewards-spend',
          label: 'How can I spend my Total REI Rewards?',
          url: '/help?a=How-can-I-spend-my-Total-REI-Rewards---id--0_UTKhMLSfWkcPCk0hbcNw',
        }],
      },
      {
        name: 'membership-rewards-question',
        label: 'Rewards question',
        showHelpLinks: true,
        links: [{
          name: 'rewards-question-co-op-reward-when',
          label: 'When do I get my Co-op Member Reward?',
          url: '/help?a=How-do-I-earn-a-Co-op-Member-Reward---id--apT8JbKWQtG5mFZwOzpjsw',
        },
        {
          name: 'rewards-question-co-op-reward-how',
          label: 'How can I spend my Total REI Rewards?',
          url: '/help?a=How-can-I-spend-my-Total-REI-Rewards---id--0_UTKhMLSfWkcPCk0hbcNw',
        },
        {
          name: 'rewards-question-expire',
          label: 'When do my Total REI Rewards Expire?',
          url: '/help?a=When-do-my-Total-REI-Rewards-expire---id--YcH5BqDdRAmRUiFLQoxh4Q',
        },
        {
          name: 'rewards-question-co-op-reward-earn',
          label: 'Can I retroactively earn a Co-op Member Reward on a previous purchase?',
          url: '/help?a=Can-I-retroactively-earn-a-Co-op-Member-Reward-on-previous-purchases---id--hxFKaRlTTe6nm8ZjwYnUsg',
        },
        {
          name: 'rewards-question-FAQ',
          label: 'All membership FAQs',
          url: '/membership#faq',
        }],
      },
      {
        name: 'membership-purchase-history',
        label: 'Purchase history',
        showHelpLinks: true,
        links: [{
          name: 'purchase-history-page',
          label: 'Purchase history page',
          url: '/OrderTrackingLoginView',
        },
        {
          name: 'purchase-history-types',
          label: 'Which transaction types are available to view on my purchase history page?',
          url: '/help?a=Which-transaction-types-are-available-to-view-on-my-Purchase-History-page---id--eKJOhdxwQzGrBNC-CfL2mw',
        },
        {
          name: 'purchase-history-which-types-not',
          label: 'Which transaction types are not available for view on my purchase history page?',
          url: '/help?a=Which-transaction-types-are-not-available-for-view-on-my-Purchase-History-page---id--icJ3LhfKRnabYK-zvqxh4A',
        }],
      },
      {
        name: 'membership-link',
        label: 'Link membership and account',
        showHelpLinks: true,
        links: [{
          name: 'membership-link-same',
          label: 'Is an REI Online Account the same thing as a membership?',
          url: '/help?a=Is-an-REI-Online-Account-the-same-thing-as-a-membership---id--gvdW_W03TbCX_LASqJ1oLg',
        },
        {
          name: 'membership-link-use',
          label: 'Can I use any membership email address for my REI Online Account?',
          url: '/help?a=Can-I-use-any-membership-email-address-for-my-REI-Online-Account---id--0ra8ySEARfu6DROp26N1GA',
        },
        {
          name: 'membership-link-updated',
          label: 'I updated my REI Online Account information, so why didn\'t it update my REI Membership?',
          url: '/help?a=I-updated-my-REI-Online-Account-information-so-why-didn%27t-it-update-my-REI-Membership---id--fu8_2QZsQRyQe5DRFwsyFg',
        },
        {
          name: 'membership-link-use-rewards',
          label: 'I have our membership number in my online account, so why is it not letting me use rewards?',
          url: '/help?a=I-have-our-membership-number-in-my-online-account-so-why-is-it-not-letting-me-use-Rewards---id--vSi9__lCSKWYFT__smNp9A',
        }],
      },
      {
        name: 'membership-change-pi',
        label: 'Change personal information',
        showHelpLinks: true,
        links: [{
          name: 'membership-change-pi-change',
          label: 'Member name change',
          url: '/help?a=Member-Name-Change-Assistance---id--vyRwc4FdR1iEHApAjsNgzg',
        },
        {
          name: 'membership-change-pi-ci-update',
          label: 'Contact information update',
          url: '/help?a=Member-Contact-Information-Updates---id--H9zx7KZ4T6qSoyiiQxvWJw',
        },
        {
          name: 'membership-change-pi-pass',
          label: 'How do I reset my REI Online Account password?',
          url: '/help?a=How-do-I-reset-my-REI-Online-Account-password---id--mNd3gTzuQzGYvIRaiZXtEw',
        },
        {
          name: 'membership-change-pi-not-found',
          label: 'It says my email address is not found, so why do I get emails from REI?',
          url: '/help?a=It-says-my-email-address-is-not-found-so-why-do-I-get-emails-from-REI---id--66TZZsn3Th63TOB2R-VsFQ',
        },
        {
          name: 'membership-change-pi-update-membership',
          label: 'I updated my REI Online Account information, so why didn\'t it update my REI Membership?',
          url: '/help?a=I-updated-my-REI-Online-Account-information-so-why-didn%27t-it-update-my-REI-Membership---id--fu8_2QZsQRyQe5DRFwsyFg',
        }],
      },
      {
        name: 'membership-rei-cc',
        label: 'REI credit card',
        showHelpLinks: true,
        links: [{
          name: 'membership-rei-cc-change',
          label: 'REI Mastercard',
          url: '/help?a=REI-Mastercard---id--Ip79_UdcR-G5Vz6_aVFEdw',
        }],
      },
      {
        name: 'membership-mbc-question',
        label: 'Member bonus card question',
        showHelpLinks: true,
        links: [{
          name: 'membership-mbc-question-add-promo',
          label: 'How do I add a promo or coupon code to my order?',
          url: '/help?a=How-do-I-add-a-promo-or-coupon-code-to-my-order?----id--dNw3-hOrThyAmrkZLc2ubQ',
        },
        {
          name: 'membership-mbc-question-coupon-isn\'t-working',
          label: 'My coupon isn\'t working, what do I do?',
          url: '/help?a=My-coupon-isn%E2%80%99t-working,-what-do-I-do?---id--xB6HIz9QTR2GWVJ2mzXoMA',
        },
        {
          name: 'membership-mbc-question-misplaced-coupon',
          label: 'I misplaced my coupon. How can I get the coupon code?',
          url: '/help?a=I-misplaced-my-coupon.-How-can-I-get-the-coupon-code?---id--bHkXClyhRBO3U1jbxtDV-A',
        },
        {
          name: 'membership-mbc-question-find-coupon-exclusions',
          label: 'Where can I find coupon exclusions?',
          url: '/help?a=Where-can-I-find-coupon-exclusions?---id--PJq9Og9jQLuZLIWlgK5hBg',
        }],
      },
      {
        name: 'membership-other',
        label: 'Other',
        showHelpLinks: true,
        links: [{
          name: 'membership-other-FAQ',
          label: 'All membership FAQs',
          url: '/membership#faq',
        }],
      },
    ],
  },
  {
    topic: 'Checkout Help',
    headline: 'Membership headline:',
    categories: [
      {
        name: 'ordering-checkout-issue',
        label: 'Checkout issue',
        showHelpLinks: true,
        links: [{
          name: 'pending-charges-on-my-card',
          label: 'Why are there pending charges on my card?',
          url: '/help?a=Authorizations-and-Charges---id--Mxt3hMjiTLajV-cje_D2dg',
        },
        {
          name: 'charged-multiple-times-for-same-order',
          label: 'Why was I charged multiple times for the same order?',
          url: '/help?a=Why-was-I-charged-multiple-times-for-the-same-order?----id--zsWTPqfgT9WKqVqQKh-3yQ&hc=paymentGiftCards&ctgry=checkoutAndPaymentIssue',
        },
        {
          name: 'email-asking-to-call-with-new-form-of-payment',
          label: 'Why did I get an email asking me to call with a new form of payment?',
          url: '/help?a=Why-did-I-get-an-email-asking-me-to-call-with-a-new-form-of-payment?---id--Bew88L6vQc24qU2jeSfojQ&hc=paymentGiftCards&ctgry=checkoutAndPaymentIssue',
        },
        {
          name: 'forms-of-payment-accepted-by-rei',
          label: 'Forms of payment accepted by REI',
          url: '/help?a=Forms-of-Payment-Accepted-by-REI---id--OpcQK70HTbC1p7C9DChpGg',
        }],
      },
      {
        name: 'ordering-payment-issue',
        label: 'Payment issue',
        showHelpLinks: true,
        links: [{
          name: 'ordering-payment-issue-authorization',
          label: 'Authorizations and charges',
          url: '/help?a=Authorizations-and-Charges---id--Mxt3hMjiTLajV-cje_D2dg',
        },
        {
          name: 'ordering-payment-issue-payments',
          label: 'Forms of payment accepted by REI',
          url: '/help?a=Forms-of-Payment-Accepted-by-REI---id--OpcQK70HTbC1p7C9DChpGg',
        }],
      },
      {
        name: 'ordering-coupon-issue',
        label: 'Coupon issue',
        showHelpLinks: true,
        links: [{
          name: 'ordering-coupon-issue-coupon-isn\'t-working',
          label: 'My coupon isn\'t working what do I do?',
          url: '/help?a=My-coupon-isn%E2%80%99t-working,-what-do-I-do?---id--xB6HIz9QTR2GWVJ2mzXoMA',
        },
        {
          name: 'ordering-coupon-issue-add-promo-to-order',
          label: 'How do I add a promo or coupon code to my order?',
          url: '/help?a=How-do-I-add-a-promo-or-coupon-code-to-my-order?----id--dNw3-hOrThyAmrkZLc2ubQ',
        },
        {
          name: 'ordering-coupon-issue-misplaced-coupon',
          label: 'I misplaced my coupon. How can I get the coupon code?',
          url: '/help?a=I-misplaced-my-coupon.-How-can-I-get-the-coupon-code?---id--bHkXClyhRBO3U1jbxtDV-A',
        }],
      },
      {
        name: 'ordering-gc-question',
        label: 'Gift card question',
        showHelpLinks: true,
        links: [{
          name: 'ordering-gc-question-order-online',
          label: 'Placing a gift order online',
          url: '/help?a=Placing-a-Gift-Order-Online---id--WS6SBln1SQ2ODz_T1tXDmA',
        },
        {
          name: 'ordering-gc-question-balance',
          label: 'Check gift card or eGift card balance',
          url: '/GiftCertificateBalance',
        },
        {
          name: 'ordering-gc-question-use',
          label: 'How to use your gift card',
          url: '/gift-card/redeem',
        },
        {
          name: 'ordering-gc-question-lost',
          label: 'Lost your gift card?',
          url: '/help?a=Lost-Your-Gift-Card---id--TeZiaC0mSEyC_DY7iiZSEQ',
        },
        {
          name: 'ordering-gc-question-landing',
          label: 'Gift & eGift card landing page',
          url: '/gift-card/purchase',
        }],
      },
      {
        name: 'ordering-digital-payments',
        label: 'Digital payments (PayPal, Apple Pay, etc.)',
        showHelpLinks: true,
        links: [{
          name: 'ordering-digital-payments-buy-now',
          label: 'Buy now, pay later at REI',
          url: '/help?a=Buy-Now-Pay-Later-at-REI---id--zoJSd-OETdi4dG0ql3wGEw',
        },
        {
          name: 'ordering-digital-payments-auth',
          label: 'Authorizations and charges',
          url: '/help?a=Authorizations-and-Charges---id--Mxt3hMjiTLajV-cje_D2dg',
        },
        {
          name: 'ordering-digital-payments-forms',
          label: 'Forms of payment accepted by REI',
          url: '/help?a=Forms-of-Payment-Accepted-by-REI---id--OpcQK70HTbC1p7C9DChpGg',
        }],
      },
      {
        name: 'ordering-multiple-tenders',
        label: 'Multiple tenders',
        showHelpLinks: true,
        links: [{
          name: 'ordering-multiple-tenders-auth',
          label: 'Authorizations and charges',
          url: '/help?a=Authorizations-and-Charges---id--Mxt3hMjiTLajV-cje_D2dg',
        },
        {
          name: 'ordering-multiple-tenders-forms',
          label: 'Forms of payment accepted by REI',
          url: '/help?a=Forms-of-Payment-Accepted-by-REI---id--OpcQK70HTbC1p7C9DChpGg',
        }],
      },
      {
        name: 'ordering-pricing-questions',
        label: 'Pricing questions',
        showHelpLinks: true,
        links: [{
          name: 'ordering-pricing-questions-info',
          label: 'Pricing information',
          url: '/help?a=Pricing---id--XTSs-3gJSE-8Raa-z8x3uA',
        },
        {
          name: 'ordering-pricing-questions-pa',
          label: 'Price adjustment request',
          url: '/help/price-adjustment',
        },
        {
          name: 'ordering-pricing-questions-pm',
          label: 'Price matching info',
          url: '/help?a=Price-Matching---id--dEt-_zDURQW0H_iyi8QYug',
        },
        {
          name: 'ordering-pricing-questions-st',
          label: 'Sales tax info',
          url: '/help?a=Sales-Tax---id--cNL33FN9R6aho7QE2zPzeg',
        }],
      },
      {
        name: 'ordering-other',
        label: 'Other',
        showHelpLinks: true,
        links: [{
          name: 'ordering-other-coupon-isn\'t-working',
          label: 'My coupon isn\'t working what do I do?',
          url: '/help?a=My-coupon-isn%E2%80%99t-working,-what-do-I-do?---id--xB6HIz9QTR2GWVJ2mzXoMA',
        },
        {
          name: 'ordering-other-misplaced-coupon',
          label: 'I misplaced my coupon. How can I get the coupon code?',
          url: '/help?a=I-misplaced-my-coupon.-How-can-I-get-the-coupon-code?---id--bHkXClyhRBO3U1jbxtDV-A',
        },
        {
          name: 'ordering-other-find-coupon-exclusions',
          label: 'Where can I find coupon exclusions?',
          url: '/help?a=Where-can-I-find-coupon-exclusions?---id--PJq9Og9jQLuZLIWlgK5hBg',
        }],
      },
    ],
  },
  {
    topic: 'Product Advice / Availability',
    headline: 'Product information headline:',
    name: 'product-advice',
    categories: [
      {
        name: 'product-sizing',
        label: 'Sizing',
        showHelpLinks: true,
        links: [{
          name: 'product-sizing-clothing',
          label: 'Clothing',
          url: '/help?a=Sizing-Clothing---id--MM59GpKySRyqzJ3cfVWw8A',
        },
        {
          name: 'product-sizing-backpacks',
          label: 'Backpacks',
          url: '/help?a=Sizing-Backpacks---id--OremaZvRQZqiXL3nftyR8w',
        },
        {
          name: 'product-sizing-bike',
          label: 'Bike',
          url: '/help?a=Sizing-Bikes---id--ETnHGHIoRUiOJBN6XvKw7g',
        }],
      },
      {
        name: 'product-gear-guides',
        label: 'Gear guides',
        showHelpLinks: true,
        links: [{
          name: 'product-gear-guides-camping',
          label: 'Camping',
          url: '/learn/c/camping/t/gear-guides?ir=category%3Acamping&r=c%3Bt',
        },
        {
          name: 'product-gear-guides-hiking',
          label: 'Hiking',
          url: '/learn/c/hiking/t/gear-guides?ir=category%3Ahiking&r=c%3Bt',
        },
        {
          name: 'product-gear-guides-cycling',
          label: 'Cycling',
          url: '/learn/c/cycling/t/gear-guides?ir=category%3Acycling&r=c%3Bt',
        },
        {
          name: 'product-gear-guides-running',
          label: 'Running',
          url: '/learn/c/running/t/gear-guides?ir=category%3Arunning&r=c%3Bt',
        },
        {
          name: 'product-gear-guides-all-expert',
          label: 'All expert advice',
          url: '/learn/expert-advice',
        }],
      },
      {
        name: 'product-buying-advice',
        label: 'Buying advice',
        showHelpLinks: true,
        links: [{
          name: 'product-buying-advice-camping',
          label: 'Camping',
          url: '/learn/c/camping/t/gear-guides?ir=category%3Acamping&r=c%3Bt',
        },
        {
          name: 'product-buying-advice-hiking',
          label: 'Hiking',
          url: '/learn/c/hiking/t/gear-guides?ir=category%3Ahiking&r=c%3Bt',
        },
        {
          name: 'product-buying-advice-cycling',
          label: 'Cycling',
          url: '/learn/c/cycling/t/gear-guides?ir=category%3Acycling&r=c%3Bt',
        },
        {
          name: 'product-buying-advice-running',
          label: 'Running',
          url: '/learn/c/running/t/gear-guides?ir=category%3Arunning&r=c%3Bt',
        },
        {
          name: 'product-buying-advice-all-expert',
          label: 'All expert advice',
          url: '/learn/expert-advice',
        }],
      },
      {
        name: 'product-care-repair',
        label: 'Care and repair',
        showHelpLinks: true,
        links: [{
          name: 'product-care-repair-camping',
          label: 'Camping',
          url: '/learn/c/camping/t/gear-guides?ir=category%3Acamping&r=c%3Bt',
        },
        {
          name: 'product-care-repair-hiking',
          label: 'Hiking',
          url: '/learn/c/hiking/t/gear-guides?ir=category%3Ahiking&r=c%3Bt',
        },
        {
          name: 'product-care-repair-cycling',
          label: 'Cycling',
          url: '/learn/c/cycling/t/gear-guides?ir=category%3Acycling&r=c%3Bt',
        },
        {
          name: 'product-care-repair-running',
          label: 'Running',
          url: '/learn/c/running/t/gear-guides?ir=category%3Arunning&r=c%3Bt',
        },
        {
          name: 'product-care-repair-all-expert',
          label: 'All expert advice',
          url: '/learn/expert-advice',
        }],
      },
      {
        name: 'product-check-lists',
        label: 'Checklists',
        showHelpLinks: true,
        links: [{
          name: 'product-check-lists-camping',
          label: 'Camping',
          url: '/learn/c/camping/t/gear-guides?ir=category%3Acamping&r=c%3Bt',
        },
        {
          name: 'product-check-lists-hiking',
          label: 'Hiking',
          url: '/learn/c/hiking/t/gear-guides?ir=category%3Ahiking&r=c%3Bt',
        },
        {
          name: 'product-check-lists-cycling',
          label: 'Cycling',
          url: '/learn/c/cycling/t/gear-guides?ir=category%3Acycling&r=c%3Bt',
        },
        {
          name: 'product-check-lists-running',
          label: 'Running',
          url: '/learn/c/running/t/gear-guides?ir=category%3Arunning&r=c%3Bt',
        },
        {
          name: 'product-check-lists-all-expert',
          label: 'All expert advice',
          url: '/learn/expert-advice',
        }],
      },
      {
        name: 'product-recipes',
        label: 'Recipes',
        showHelpLinks: true,
        links: [{
          name: 'product-recipes-camping',
          label: 'Camping',
          url: '/learn/c/camping/t/recipes?ir=category%3Acamping&r=c%3Bt',
        },
        {
          name: 'product-recipes-hiking',
          label: 'Hiking',
          url: '/learn/c/hiking/t/recipes?ir=category%3Ahiking&r=c%3Bt',
        },
        {
          name: 'product-recipes-family',
          label: 'Family',
          url: '/learn/c/family/t/recipes?ir=category%3Afamily&r=c%3Bt',
        },
        {
          name: 'product-check-lists-all-expert',
          label: 'All expert advice',
          url: '/learn/expert-advice',
        }],
      },
      {
        name: 'product-skills',
        label: 'Skills',
        showHelpLinks: true,
        links: [{
          name: 'product-skills-camping',
          label: 'Camping',
          url: '/learn/c/camping/t/gear-guides?ir=category%3Acamping&r=c%3Bt',
        },
        {
          name: 'product-skills-hiking',
          label: 'Hiking',
          url: '/learn/c/hiking/t/gear-guides?ir=category%3Ahiking&r=c%3Bt',
        },
        {
          name: 'product-skills-cycling',
          label: 'Cycling',
          url: '/learn/c/cycling/t/gear-guides?ir=category%3Acycling&r=c%3Bt',
        },
        {
          name: 'product-skills-running',
          label: 'Running',
          url: '/learn/c/running/t/gear-guides?ir=category%3Arunning&r=c%3Bt',
        },
        {
          name: 'product-skills-all-expert',
          label: 'All expert advice',
          url: '/learn/expert-advice',
        }],
      },
      {
        name: 'product-safety',
        label: 'Safety, hazardous, oversize',
        showHelpLinks: true,
        links: [{
          name: 'product-safety-recalls',
          label: 'Product safety and recalls',
          url: '/help/product-safety-and-recalls.html',
        },
        {
          name: 'product-safety-oversize-items',
          label: 'Oversize items',
          url: '/help?a=Oversize-Items---id--fVnCvqdcT4qM1dK_ArhBvA',
        },
        {
          name: 'product-safety-hazardous-items',
          label: 'Hazardous items',
          url: '/help?a=Hazardous-Items---id--Q8xCgQWgSzyLjcnt3WEhpw',
        }],
      },
      { name: 'product-inventory', label: 'Inventory', links: [] },
      { name: 'product-other', label: 'Other', links: [] },
    ],
  },
  {
    topic: 'Delivery Issues',
    headline: 'Delivery Issues headline:',
    categories: [
      {
        name: 'order-track',
        label: 'Track my order',
        showHelpLinks: true,
        showOrderNumber: true,
        orderNumberRequired: false,
        links: [{
          name: 'order-track-tracking',
          label: 'Track my order',
          url: '/OrderTrackingLoginView',
        },
        {
          name: 'order-track-how-long',
          label: 'How long does it take for my order to ship after it\'s been placed?',
          url: '/help?a=How-long-does-it-take-for-my-order-to-ship-after-it%27s-been-placed---id--6V9RvEOeQvCdAcxBjm5ItA',
        },
        {
          name: 'order-track-not-here',
          label: 'Order tracking says my order was delivered, but it\'s not here. What do I do?',
          url: '/help?a=Order-tracking-says-my-order-was-delivered,-but-it%27s-not-here.-What-do-I-do?---id--KrgeKrKdQ4qFZFNW8gbkvw',
        }],
      },
      {
        name: 'order-package-not-arrived',
        label: 'Package hasn\'t arrived / late',
        showHelpLinks: true,
        showOrderNumber: true,
        orderNumberRequired: true,
        links: [{
          name: 'order-package-not-arrived-here',
          label: 'Order tracking says my order was delivered, but it\'s not here. What do I do?',
          url: '/help?a=Order-tracking-says-my-order-was-delivered-but-it%27s-not-here.-What-do-I-do---id--KrgeKrKdQ4qFZFNW8gbkvw',
        },
        {
          name: 'order-track-report-delivery-issue',
          label: 'Report a delivery issue',
          url: '/help/delivery-issues',
        },
        {
          name: 'order-package-not-arrived-how-long',
          label: 'How long does it take for my order to ship after it\'s been placed?',
          url: '/help?a=How-long-does-it-take-for-my-order-to-ship-after-it%27s-been-placed---id--6V9RvEOeQvCdAcxBjm5ItA',
        },
        {
          name: 'order-package-not-arrived-tracking',
          label: 'Order tracking',
          url: '/OrderTrackingLoginView',
        },
        {
          name: 'order-package-not-arrived-shipping',
          label: 'Shipping timeline',
          url: '/help/shipping-timelines.html',
        }],
        deepLink: true,
        deepLinkConfig: {
          chosenPath: pathNames.TRACKING_SHOW_BUT_NOT_HERE,
          pathConfig: getPathConfiguration(pathNames.TRACKING_SHOW_BUT_NOT_HERE),
          redirectToAppURL: '/help/delivery-issues-check',
          componentName: componentNames.INFORMATION_PAGE,
        },
        setDeliveryStorage: true,
        isRedirectToApp: true,
        redirectToAppURL: '/help/delivery-issues',
      },
      {
        name: 'order-package-missing',
        label: 'Package is missing / lost',
        showHelpLinks: true,
        showOrderNumber: true,
        orderNumberRequired: true,
        isRedirectToApp: true,
        deepLink: true,
        deepLinkConfig: {
          chosenPath: pathNames.LOST_ORDER,
          pathConfig: getPathConfiguration(pathNames.LOST_ORDER),
          redirectToAppURL: '/help/delivery-issues-check',
          componentName: componentNames.INFORMATION_PAGE,
        },
        setDeliveryStorage: true,
        redirectToAppURL: '/help/delivery-issues',
        links: [{
          name: 'order-package-missing-here',
          label: 'Order tracking says my order was delivered, but it\'s not here. What do I do?',
          url: '/help?a=Order-tracking-says-my-order-was-delivered-but-it%27s-not-here.-What-do-I-do---id--KrgeKrKdQ4qFZFNW8gbkvw',
        },
        {
          name: 'order-package-missing-sent',
          label: 'My order was sent to the wrong address, what do I do?\n',
          url: '/help?a=My-order-was-sent-to-the-wrong-address-what-do-I-do---id--_XEGf1A9RAqKjuyOislzow',
        },
        {
          name: 'order-track-report-delivery-issue',
          label: 'Report a delivery issue',
          url: '/help/delivery-issues',
        },
        {
          name: 'order-package-missing-tracking',
          label: 'Order tracking',
          url: '/OrderTrackingLoginView',
        }],
      },
      {
        name: 'order-item-missing',
        label: 'An item is missing from my order',
        showHelpLinks: true,
        showOrderNumber: true,
        orderNumberRequired: true,
        isRedirectToApp: true,
        deepLink: true,
        deepLinkConfig: {
          chosenPath: pathNames.MISSING_ITEM,
          pathConfig: getPathConfiguration(pathNames.MISSING_ITEM),
          redirectToAppURL: '/help/delivery-issues-check',
          componentName: componentNames.INFORMATION_PAGE,
        },
        setDeliveryStorage: true,
        redirectToAppURL: '/help/delivery-issues',
        links: [
          {
            name: 'order-track-report-delivery-issue',
            label: 'Report a delivery issue',
            url: '/help/delivery-issues',
          },
          {
            name: 'order-item-missing-tracking',
            label: 'Order tracking',
            url: '/OrderTrackingLoginView',
          }],
      },
      {
        name: 'order-wrong',
        label: 'I received the wrong order',
        showHelpLinks: true,
        showOrderNumber: true,
        orderNumberRequired: true,
        isRedirectToApp: true,
        deepLink: true,
        deepLinkConfig: {
          chosenPath: pathNames.INCORRECT_ITEM,
          pathConfig: getPathConfiguration(pathNames.INCORRECT_ITEM),
          redirectToAppURL: '/help/delivery-issues-order',
          componentName: componentNames.WRONG_ORDER_INFO,
        },
        setDeliveryStorage: true,
        redirectToAppURL: '/help/delivery-issues-order',
        links: [{
          name: 'order-wrong-item',
          label: 'I was shipped the wrong item, what do I do?',
          url: '/help?a=I-was-shipped-the-wrong-item-what-do-I-do---id--XPPK-IWCS7WjZmLtz7V8QA',
        },
        {
          name: 'order-track-report-delivery-issue',
          label: 'Report a delivery issue',
          url: '/help/delivery-issues',
        },
        {
          name: 'order-wrong-tracking',
          label: 'Order tracking',
          url: '/OrderTrackingLoginView',
        }],
      },
      {
        name: 'order-damaged-defective-items',
        label: 'Damaged / defective items',
        showOrderNumber: true,
        orderNumberRequired: false,
        redirectToAppURL: '/help/delivery-issues',
        links: [{
          name: 'order-track-report-delivery-issue',
          label: 'Report a delivery issue',
          url: '/help/delivery-issues',
        },
        {
          name: 'order-product-damaged',
          label: 'What do I do if my product is damaged or defective',
          url: '/help?a=What-do-I-do-if-my-product-is-damaged-or-defective---id--bq4EhPY5QbCc9gcqnYje6Q',
        }],
      },
      {
        name: 'order-shipping-question',
        label: 'Shipping question',
        showHelpLinks: true,
        links: [{
          name: 'order-shipping-question-FAQs',
          label: 'Shipping FAQs',
          url: '/help/shipping',
        },
        {
          name: 'order-shipping-question-shipping',
          label: 'How long does it take for my order to ship after it\'s been placed?',
          url: '/help?a=How-long-does-it-take-for-my-order-to-ship-after-it%27s-been-placed---id--6V9RvEOeQvCdAcxBjm5ItA',
        }],
      },
      {
        name: 'order-international-question',
        label: 'International question',
        showHelpLinks: true,
        links: [{
          name: 'order-international-question-order',
          label: 'International orders info',
          url: '/help?a=International-Orders---id--fXTvVDsjSC-ZYRXa04hRYg',
        }],
      },
      {
        name: 'order-backorder-question',
        label: 'Backorder or pre-order question',
        showHelpLinks: true,
        links: [{
          name: 'order-backorder-question-bpo',
          label: 'Backorders & pre-orders info',
          url: '/help?a=Backorders-and-Pre-orders---id--eNWWr165RsuT_lmta3iV7A',
        }],
      },
      {
        name: 'order-status-other',
        label: 'Other',
        showHelpLinks: true,
        links: [{
          name: 'order-status-other-all-shipping-articles',
          label: 'All shipping articles',
          url: '/help/categories?hc=shippingInformation',
        },
        {
          name: 'order-status-other-shipping-how-long',
          label: 'How long does it take for my order to ship after it\'s been placed?',
          url: '/help?a=How-long-does-it-take-for-my-order-to-ship-after-it%27s-been-placed---id--6V9RvEOeQvCdAcxBjm5ItA',
        },
        {
          name: 'order-status-other-order-not-here',
          label: 'Order tracking says my order was delivered, but it\'s not here. What do I do?',
          url: '/help?a=Order-tracking-says-my-order-was-delivered,-but-it%27s-not-here.-What-do-I-do?---id--KrgeKrKdQ4qFZFNW8gbkvw',
        }],
      },
    ],
  },
  {
    topic: 'Cancel / Modify Order',
    headline: 'Cancel / Modify Order headline:',
    categories: [
      {
        name: 'modify-order-cancel',
        label: 'Cancel order',
        showHelpLinks: true,
        links: [{
          name: 'modify-order-cancel-can-i',
          label: 'Can I cancel my order?',
          url: '/help?a=Can-I-cancel-my-order---id--RunjZv_yTdO4Cewe5IZs9g',
        },
        {
          name: 'modify-order-change-FAQ',
          label: 'Changing an order FAQ',
          url: '/help?a=Changing-an-Order-FAQ---id--0N2ZHCdlQKWFRBDaHOhV0w',
        },
        {
          name: 'modify-order-purchase',
          label: 'Purchase status',
          url: '/PurchaseTrackingLoginView',
        },
        {
          name: 'modify-order-price-adjustment',
          label: 'Price adjustment request',
          url: '/help/price-adjustment',
        },
        {
          name: 'modify-order-store-pickup',
          label: 'Store pickup info',
          url: '/help/curbside-pickup',
        }],
      },
      {
        name: 'modify-order-change-product',
        label: 'Change product on my order',
        showHelpLinks: true,
        links: [{
          name: 'modify-order-change-product-can-i',
          label: 'Can I change the product or quantity on my order?',
          url: '/help?a=Can-I-change-the-product-or-quantity-on-my-order---id--l3oAbLiaTGuFcLK1X6EHNg',
        },
        {
          name: 'modify-order-change-product-FAQ',
          label: 'Changing an order FAQ',
          url: '/help?a=Changing-an-Order-FAQ---id--0N2ZHCdlQKWFRBDaHOhV0w',
        }],
      },
      {
        name: 'modify-order-change-billing-address',
        label: 'Change billing address',
        showHelpLinks: true,
        links: [{
          name: 'modify-order-change-billing-address-can-i',
          label: 'Can I change the billing address on my order?',
          url: '/help?a=Can-I-change-the-billing-address-on-my-order---id--pHYC-JyxTiallAbN830UGA',
        },
        {
          name: 'modify-order-change-billing-address-FAQ',
          label: 'Changing an order FAQ',
          url: '/help?a=Changing-an-Order-FAQ---id--0N2ZHCdlQKWFRBDaHOhV0w',
        }],
      },
      {
        name: 'modify-order-change-shipping-address',
        label: 'Change shipping address',
        showHelpLinks: true,
        links: [{
          name: 'modify-order-change-shipping-address-can-i',
          label: 'Can I change the shipping address on my order?',
          url: '/help?a=Can-I-change-the-shipping-address-on-my-order---id--I-mhVFUlSyaHzwc-UWOaMA',
        },
        {
          name: 'modify-order-change-shipping-address-FAQ',
          label: 'Changing an order FAQ',
          url: '/help?a=Changing-an-Order-FAQ---id--0N2ZHCdlQKWFRBDaHOhV0w',
        }],
      },
      {
        name: 'modify-order-change-payment',
        label: 'Change payment details',
        showHelpLinks: true,
        links: [{
          name: 'modify-order-change-payment-can-i',
          label: 'Can I change the payment details on my order?',
          url: '/help?a=Can-I-change-the-payment-details-on-my-order---id--eRg0JS5GQ0OI_MDyWXuS3w',
        },
        {
          name: 'modify-order-change-payment-FAQ',
          label: 'Changing an order FAQ',
          url: '/help?a=Changing-an-Order-FAQ---id--0N2ZHCdlQKWFRBDaHOhV0w',
        }],
      },
      {
        name: 'modify-order-price',
        label: 'Price adjustment',
        showHelpLinks: true,
        links: [{
          name: 'order-track-tracking',
          label: 'Price adjustment',
          url: '/help/price-adjustment',
        },
        {
          name: 'order-track-shipping',
          label: 'Price matching info',
          url: '/help?a=Price-Matching---id--dEt-_zDURQW0H_iyi8QYug',
        }],
        showOrderNumber: true,
        orderNumberRequired: false,
        isRedirectToApp: true,
        redirectToAppURL: '/help/price-adjustment',
      },
      {
        name: 'modify-order-other',
        label: 'Other',
        showHelpLinks: true,
        links: [{
          name: 'modify-order-other-can-i-cancel-order',
          label: 'Can I cancel my order?',
          url: '/help?a=Can-I-cancel-my-order---id--RunjZv_yTdO4Cewe5IZs9g',
        },
        {
          name: 'modify-order-other-can-i-change-product',
          label: 'Can I change the product or quantity on my order?',
          url: '/help?a=Can-I-change-the-product-or-quantity-on-my-order---id--l3oAbLiaTGuFcLK1X6EHNg',
        },
        {
          name: 'modify-order-other-can-i-change-billing-address',
          label: 'Can I change the billing address on my order?',
          url: '/help?a=Can-I-change-the-billing-address-on-my-order---id--pHYC-JyxTiallAbN830UGA',
        },
        {
          name: 'modify-order-other-can-i-change-shipping-address',
          label: 'Can I change the shipping address on my order?',
          url: '/help?a=Can-I-change-the-shipping-address-on-my-order---id--I-mhVFUlSyaHzwc-UWOaMA',
        },
        {
          name: 'modify-order-other-can-i-change-payment',
          label: 'Can I change the payment details on my order?',
          url: '/help?a=Can-I-change-the-payment-details-on-my-order---id--eRg0JS5GQ0OI_MDyWXuS3w',
        }],
      },
    ],
  },
  {
    topic: 'Coupons / Promos / Gift Cards',
    headline: 'Coupons and promotion headline:',
    categories: [
      {
        name: 'coupons-issue',
        label: 'Coupon issue',
        showHelpLinks: true,
        links: [{
          name: 'coupons-issue-coupon-isn\'t-working',
          label: 'My coupon isn\'t working what do I do?',
          url: '/help?a=My-coupon-isn%E2%80%99t-working,-what-do-I-do?---id--xB6HIz9QTR2GWVJ2mzXoMA',
        },
        {
          name: 'coupons-issue-add-promo-to-order',
          label: 'How do I add a promo or coupon code to my order?',
          url: '/help?a=How-do-I-add-a-promo-or-coupon-code-to-my-order?----id--dNw3-hOrThyAmrkZLc2ubQ',
        },
        {
          name: 'coupons-issue-misplaced-coupon',
          label: 'I misplaced my coupon. How can I get the coupon code?',
          url: '/help?a=I-misplaced-my-coupon.-How-can-I-get-the-coupon-code?---id--bHkXClyhRBO3U1jbxtDV-A',
        },
        {
          name: 'coupons-issue-find-coupon-exclusions',
          label: 'Where can I find coupon exclusions?',
          url: '/help?a=Where-can-I-find-coupon-exclusions?---id--PJq9Og9jQLuZLIWlgK5hBg',
        }],
      },
      {
        name: 'coupons-promotions-question',
        label: 'Promotions question',
        showHelpLinks: true,
        links: [{
          name: 'coupons-promotions-question-rei-deals',
          label: 'REI deals, discounts, & free shipping offers',
          url: '/promotions/coupons#deals',
        },
        {
          name: 'coupons-promotions-question-rei-offers',
          label: 'Current REI offers',
          url: '/promotions/coupons#offers',
        },
        {
          name: 'coupons-promotions-question-coupons',
          label: 'Official REI coupons, coupon codes, discounts & rebates',
          url: '/promotions/coupons',
        },
        {
          name: 'coupons-promotions-question-volume',
          label: 'REI volume discounts',
          url: '/promotions/coupons#volume-discounts',
        },
        {
          name: 'coupons-promotions-question-rebates',
          label: 'Manufacturer\'s rebates',
          url: '/promotions/coupons#rebates',
        }],
      },
      {
        name: 'coupons-gc-question',
        label: 'Gift card question',
        showHelpLinks: true,
        links: [{
          name: 'coupons-gc-question-online',
          label: 'Placing a gift order online',
          url: '/help?a=Placing-a-Gift-Order-Online---id--WS6SBln1SQ2ODz_T1tXDmA',
        },
        {
          name: 'coupons-gc-question-balance',
          label: 'Check gift card or eGift card balance',
          url: '/GiftCertificateBalance',
        },
        {
          name: 'coupons-gc-question-to-use',
          label: 'How to use your gift card',
          url: '/gift-card/redeem',
        },
        {
          name: 'coupons-gc-question-lost',
          label: 'Lost your gift card?',
          url: '/help?a=Lost-Your-Gift-Card---id--TeZiaC0mSEyC_DY7iiZSEQ',
        },
        {
          name: 'coupons-gc-question-landing',
          label: 'Gift card & eGift card purchase page',
          url: '/gift-card/purchase',
        }],
      },
      { name: 'coupons-other', label: 'Other', links: [] },
    ],
  },
  {
    topic: 'My Account',
    headline: 'Online account headline:',
    categories: [
      {
        name: 'account-password-help',
        label: 'Password help',
        showHelpLinks: true,
        links: [{
          name: 'account-password-help-reset',
          label: 'How do I reset my password',
          url: '/help?a=How-do-I-reset-my-REI-Online-Account-password---id--mNd3gTzuQzGYvIRaiZXtEw',
        },
        {
          name: 'account-password-help-remember',
          label: 'I can\'t remember my password for my online account, can I request a new password online?',
          url: '/help?a=I-can%27t-remember-my-password-for-my-online-account.-Can-I-request-a-new-password-online---id--9ckyEHDpQXGkz945oE8zTw',
        },
        {
          name: 'account-password-help-what',
          label: 'I can\'t remember my user name and password, but I am a member. What should I do?',
          url: '/help?a=I-can%27t-remember-my-user-name-and-password-but-I-am-a-member.-What-should-I-do---id--KziZehTeRruseo64rd9UaA',
        }],
      },
      {
        name: 'account-purchase-history',
        label: 'Purchase history',
        showHelpLinks: true,
        links: [{
          name: 'account-purchase-history-page',
          label: 'Purchase history page',
          url: '/OrderTrackingLoginView',
        },
        {
          name: 'account-purchase-history-transaction',
          label: 'Which transaction types are available to view on my purchase history page?',
          url: '/help?a=Which-transaction-types-are-available-to-view-on-my-Purchase-History-page---id--eKJOhdxwQzGrBNC-CfL2mw',
        },
        {
          name: 'account-purchase-history-types',
          label: 'Which transaction types are not available for view on my purchase history page?',
          url: '/help?a=Which-transaction-types-are-not-available-for-view-on-my-Purchase-History-page---id--icJ3LhfKRnabYK-zvqxh4A',
        }],
      },
      {
        name: 'account-link',
        label: 'Linking account and membership',
        showHelpLinks: true,
        links: [{
          name: 'account-link-same',
          label: 'Is an REI Online Account the same thing as a membership?',
          url: '/help?a=Is-an-REI-Online-Account-the-same-thing-as-a-membership---id--gvdW_W03TbCX_LASqJ1oLg',
        },
        {
          name: 'account-link-membership-use',
          label: 'Can I use any membership email address for my REI Online Account?',
          url: '/help?a=Can-I-use-any-membership-email-address-for-my-REI-Online-Account---id--0ra8ySEARfu6DROp26N1GA',
        },
        {
          name: 'account-link-update',
          label: 'I updated my REI Online Account information, so why didn\'t it update my REI Membership?',
          url: '/help?a=I-updated-my-REI-Online-Account-information-so-why-didn%27t-it-update-my-REI-Membership---id--fu8_2QZsQRyQe5DRFwsyFg',
        },
        {
          name: 'account-link-member-number',
          label: 'I have our membership number in my online account, so why is it not letting me use rewards?',
          url: '/help?a=I-have-our-membership-number-in-my-online-account-so-why-is-it-not-letting-me-use-Rewards---id--vSi9__lCSKWYFT__smNp9A',
        }],
      },
      {
        name: 'account-change-pi',
        label: 'Changing personal details',
        showHelpLinks: true,
        links: [{
          name: 'account-change-pi-member-name',
          label: 'Member name change request',
          url: '/help?a=Member-Name-Change-Assistance---id--vyRwc4FdR1iEHApAjsNgzg',
        },
        {
          name: 'account-change-pi-ci',
          label: 'Contact information update',
          url: '/help?a=Member-Contact-Information-Updates---id--H9zx7KZ4T6qSoyiiQxvWJw',
        },
        {
          name: 'account-change-pi-reset',
          label: 'How do I reset my REI Online Account password?',
          url: '/help?a=How-do-I-reset-my-REI-Online-Account-password---id--mNd3gTzuQzGYvIRaiZXtEw',
        },
        {
          name: 'account-change-pi-email-not-found',
          label: 'It says my email address is not found, so why do I get emails from REI?',
          url: '/help?a=It-says-my-email-address-is-not-found-so-why-do-I-get-emails-from-REI---id--66TZZsn3Th63TOB2R-VsFQ',
        },
        {
          name: 'account-change-pi-see-changes',
          label: 'I updated my REI online account. Why can\'t I see the changes?',
          url: '/help?a=I-updated-my-REI-Online-Account-information-so-why-didn%27t-it-update-my-REI-Membership---id--fu8_2QZsQRyQe5DRFwsyFg',
        }],
      },
      {
        name: 'account-email-preference',
        label: 'Email preference settings',
        showHelpLinks: true,
        links: [{
          name: 'account-email-preferences',
          label: 'Email preferences',
          url: '/email-validation',
        }],
      },
      { name: 'account-other', label: 'Other', links: [] },
    ],
  },
  {
    topic: 'REI Programs (Adventures, Rentals, Used Gear, Classes, Etc.)',
    headline: 'REI Programs:',
    categories: [
      {
        name: 'REI-rentals',
        label: 'Rentals',
        showHelpLinks: true,
        links: [{
          name: 'REI-rentals-page',
          label: 'Rentals info',
          url: '/stores/rentals',
        },
        {
          name: 'REI-rentals-FAQ',
          label: 'Rentals FAQ',
          url: '/help?a=REI-Rentals-FAQ--id-R_gD7yImSwGUDWaiBHPZeA',
        }],
      },
      {
        name: 'REI-classes-events',
        label: 'Classes & events',
        showHelpLinks: true,
        links: [{
          name: 'REI-classes-events-page',
          label: 'Classes & Events info',
          url: '/events',
        },
        {
          name: 'REI-classes-events-FAQ',
          label: 'Classes & Events FAQ',
          url: '/events/resources/faqs',
        },
        {
          name: 'REI-classes-events-cancel',
          label: 'Event cancellation details',
          url: '/events/resources/cancellation',
        }],
      },
      {
        name: 'REI-used-gear',
        label: 'Used gear',
        showHelpLinks: true,
        links: [{
          name: 'REI-used-gear-page',
          label: 'Browse used gear',
          url: '/used',
        },
        {
          name: 'REI-used-gear-FAQs',
          label: 'Used gear FAQs',
          url: '/used/faq',
        }],
      },
      {
        name: 'REI-adventures',
        label: 'Adventures',
        showHelpLinks: true,
        links: [{
          name: 'REI-adventures-page',
          label: 'Browse Adventures',
          url: '/adventures',
        },
        {
          name: 'REI-adventures-travel-FAQ',
          label: 'Travel FAQs',
          url: '/adventures/resources/faqs',
        },
        {
          name: 'REI-adventures-where-operate',
          label: 'Where we operate',
          url: '/adventures/resources/where-we-operate',
        },
        {
          name: 'REI-adventures-travel-insurance',
          label: 'Travel insurance',
          url: '/adventures/resources/travel-insurance',
        },
        {
          name: 'REI-adventures-solo-travel',
          label: 'Solo travel',
          url: '/adventures/resources/solo-travel',
        }],
      },
      {
        name: 'REI-cgs',
        label: 'Corporate group sales',
        showHelpLinks: true,
        links: [{
          name: 'REI-cgs-how-to',
          label: 'How to order for corporate and group sales',
          url: '/corporate-group-sales',
        },
        {
          name: 'REI-cgs-gear-estimate',
          label: 'Gear estimate',
          url: '/corporate-group-sales/gear-estimate',
        },
        {
          name: 'REI-cgs-bulk-gift-cards',
          label: 'Bulk gift cards',
          url: '/corporate-group-sales/bulk-gift-cards',
        }],
      },
      {
        name: 'REI-store-questions',
        label: 'Retail store questions',
        showHelpLinks: true,
        links: [{
          name: 'REI-store-questions-locator',
          label: 'Store locator',
          url: '/stores/map',
        }],
      },
      { name: 'REI-other', label: 'Other', links: [] },
    ],
  },
  {
    topic: 'Returns Help',
    headline: 'Returns headline:',
    categories: [
      {
        name: 'returns-start',
        label: 'Start a return',
        showHelpLinks: true,
        showOrderNumber: true,
        orderNumberRequired: false,
        links: [{
          name: 'return-to-a-store',
          label: 'Return to a store',
          url: '/help/returns#return-to-a-store',
        },
        {
          name: 'return-by-mail',
          label: 'Return by mail',
          url: '/help/returns#return-by-mail',
        },
        {
          name: 're-supply-used-gear-returns',
          label: 'Re/Supply used gear returns',
          url: '/help/returns#re-supply-used-gear-returns',
        },
        {
          name: 'gift-returns',
          label: 'Gift returns',
          url: '/help/returns#gift-returns',
        }],
      },
      {
        name: 'returns-exchange',
        label: 'Exchange',
        showHelpLinks: false,
        showOrderNumber: true,
        orderNumberRequired: false,
      },
      {
        name: 'returns-refund-status',
        label: 'Refund status',
        showHelpLinks: false,
        showOrderNumber: true,
        orderNumberRequired: false,
      },
      {
        name: 'returns-damage-items',
        label: 'Defective issues',
        showHelpLinks: false,
        showOrderNumber: true,
        orderNumberRequired: false,
      },
      {
        name: 'order-track-report-delivery-issue',
        label: 'Report a delivery issue',
        showHelpLinks: false,
        showOrderNumber: true,
        orderNumberRequired: false,
        isRedirectToApp: true,
        redirectToAppURL: '/help/delivery-issues',
      },
      {
        name: 'returns-label',
        label: 'Returning items from multiple orders',
        showOrderNumber: true,
        orderNumberRequired: false,
      },
      {
        name: 'returns-label-packaging',
        label: 'No receipt or original packaging',
        showHelpLinks: true,
        showOrderNumber: true,
        orderNumberRequired: false,
        links: [{
          name: 'need-a-receipt',
          label: 'Do I need a receipt or packing slip?',
          url: '/help?a=Do-I-need-a-receipt-or-packing-slip-to-return-my-item?---id--rQk1G_NnQNy-xquMLAymTA',
        },
        {
          name: 'need-original-packaging',
          label: 'Do I need the original packaging',
          url: '/help?a=Do-I-need-to-return-using-the-original-packaging?---id--bmdAPhauT-GdOk_1lxhR5g',
        }],
      },
      {
        name: 'modify-order-price',
        label: 'Request a price adjustment',
        showHelpLinks: false,
        showOrderNumber: true,
        orderNumberRequired: false,
        isRedirectToApp: true,
        redirectToAppURL: '/help/price-adjustment',
      },
      {
        name: 'returns-label-used',
        label: 'Returning sale / used items',
        showHelpLinks: true,
        showOrderNumber: true,
        orderNumberRequired: false,
        links: [{
          name: 'return-items-bought-on-sale',
          label: 'Can I return items I bought on sale, with a coupon, or from REI Outlet?',
          url: '/help?a=Can-I-return-an-item-I-bought-on-sale,-with-a-coupon,-or-from-REI-Outlet?---id--PAW5sM9VTfqecMK40djgJQ',
        },
        {
          name: 'return-worn-used-items',
          label: 'Can I return worn or used items',
          url: '/help?a=Can-I-return-worn-or-used-items?---id--n7FE21UiSCyTKbTJrdWR7A',
        }],
      },
      {
        name: 'returns-label-outside',
        label: 'Returning outside return window',
        showHelpLinks: false,
        showOrderNumber: true,
        orderNumberRequired: false,
      },
      {
        name: 'returns-other',
        label: 'Other',
        showHelpLinks: true,
        showOrderNumber: true,
        orderNumberRequired: false,
        links: [{
          name: 'returns-other-exchange-item',
          label: 'How do I exchange or replace an item?',
          url: '/help?a=How-do-I-exchange-or-replace-an-item---id--WvF9A3y8QRqdyOAyT5iSJA',
        },
        {
          name: 'returns-other-how-long-to-refunded',
          label: 'How long does it take for my return to be refunded?',
          url: '/help?a=How-long-does-it-take-for-my-return-to-be-refunded?---id--IvCCiG0SQ46UhK0ivHF1zA',
        },
        {
          name: 'returns-other-return-to-store',
          label: 'Return to store',
          url: '/help/returns#return-to-a-store',
        },
        {
          name: 'returns-other-return-by-mail',
          label: 'Return by mail',
          url: '/help/returns#return-by-mail',
        },
        {
          name: 'returns-other-if-product-damaged',
          label: 'What do I do if my product is damaged or defective?',
          url: '/help?a=What-do-I-do-if-my-product-is-damaged-or-defective---id--bq4EhPY5QbCc9gcqnYje6Q',
        },
        {
          name: 'returns-other-price-adjustment',
          label: 'Price adjustment request',
          url: '/help/price-adjustment',
        }],
      },
    ],
  },
];

export default {
  secondaryCategoryOnPrimary,
};
